module.exports = __webpack_public_path__ + "public-ui/img/g2.2a348dd7.svg";